import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

const TermsPage = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <>
      <section
        className="bg-light position-relative overflow-hidden"
        style={{ "--bs-bg-opacity": 0.8 }}
      >
        {/* Decorative Patterns */}
        <div
          className="position-absolute top-0 start-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="180" height="180" viewBox="0 0 200 200">
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(0, 0)"
            ></path>
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(80, 80)"
            ></path>
          </svg>
        </div>
        <div
          className="position-absolute bottom-0 end-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="150" height="150" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" fill="#6B72E0"></circle>
            <circle cx="50" cy="50" r="35" fill="#ffffff"></circle>
            <circle cx="50" cy="50" r="20" fill="#6B72E0"></circle>
          </svg>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div
                className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fas fa-shield-alt fa-lg text-white"></i>
              </div>
              <h1
                className="fw-bold text-primary-custom mb-3"
                data-aos="fade-up"
              >
                {" "}
                {t("terms.heading")}
              </h1>

              <p className="lead mb-4" data-aos="fade-up" data-aos-delay="200">
                {t("terms.introduction")}
              </p>

              <div className="row g-4 mb-4">
                {[1, 2, 3].map((section, index) => (
                  <div
                    className="col-lg-4"
                    key={section}
                    data-aos="fade-up"
                    data-aos-delay={200 + index * 100}
                  >
                    <div className="term-card text-center">
                      <div className="term-card-icon">
                        <i
                          className={`fas fa-${
                            index === 0
                              ? "book"
                              : index === 1
                              ? "shield-alt"
                              : "balance-scale"
                          }`}
                        ></i>
                      </div>
                      <h2>{t(`terms.section${section}.title`)}</h2>
                      <p>{t(`terms.section${section}.content`)}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div
                className="closing-card"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <p>{t("terms.closing")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .main-title {
          font-size: 3rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .term-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 1rem;
          height: 100%;
          transition: all 0.3s ease;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
        }

        .term-card-icon {
          width: 40px;
          height: 40px;
          background: #e3f2fd;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem auto;
        }

        .term-card-icon i {
          font-size: 1.8rem;
          color: #1976d2;
        }

        .term-card h2 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #1a237e;
          margin-bottom: 0.8rem;
        }

        .term-card p {
          font-size: 1.2rem;
          line-height: 1.6;
          color: #333;
          margin: 0;
        }

        .closing-card p {
          font-size: 1.4rem;
          font-style: italic;
          color: #546e7a;
          margin: 0;
        }

        @media (max-width: 768px) {
          .main-title {
            font-size: 2.4rem;
          }

          .term-card {
            padding: 0.8rem;
          }

          .term-card h2 {
            font-size: 1.5rem;
          }

          .term-card p {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </>
  );
};

export default TermsPage;
